export function toHex(bytes: Uint8Array): string {
  let out = "";
  for (const b of bytes) out += b.toString(16).padStart(2, "0");
  return out;
}

export function fromBase64(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

/** Extract all DER blobs from a PEM bundle. */
export function pemToDer(pem: string): Uint8Array[] {
  const blocks = pem.match(
    /-----BEGIN [A-Z0-9 ]+-----([A-Za-z0-9+/=\s]+?)-----END [A-Z0-9 ]+-----/g
  );
  if (!blocks) return [];
  return blocks.map((block) =>
    fromBase64(block.replace(/-----[A-Z0-9 ]+-----/g, "").replace(/\s+/g, ""))
  );
}

/** A plain ArrayBuffer copy (pkijs/asn1js want ArrayBuffer, not views). */
export function toArrayBuffer(bytes: Uint8Array): ArrayBuffer {
  return bytes.slice().buffer as ArrayBuffer;
}
